import { Validate } from '../../models/types';

export class UtilityService {
  static validate(value: string, validators: Validate[]): Validate {
    return validators.find(validator => !new RegExp(validator.expression).test(value));
  }

  static spacingIsValid(value: number): boolean {
    return !UtilityService.spacingIsInvalid(value);
  }

  static spacingIsInvalid(value: number): boolean {
    const valueIsNegative = value < 0;
    const valueValidity = valueIsNegative || value % 0.5 !== 0;
    return valueValidity;
  }
}
